import React, { createContext, useReducer, ReactNode, Dispatch } from 'react';
import Reducer, { Action, TermsCheckboxState } from '../../reducers/regform-checkboxes/terms-checkbox-reducer';

type TermsCheckboxContextType = [TermsCheckboxState, Dispatch<Action>];

const initialState: TermsCheckboxState = {
	value: false,
	error: {
		message: '',
		show: false,
	},
	valid: null,
};

export const TermsCheckboxContext = createContext<TermsCheckboxContextType>([initialState, () => null]);

interface TermsCheckboxStoreProps {
	children: ReactNode;
}

const TermsCheckboxStore: React.FC<TermsCheckboxStoreProps> = ({ children }) => {
	const [state, dispatch] = useReducer(Reducer, initialState);
	return (
		<TermsCheckboxContext.Provider value={[state, dispatch]}>
			{children}
		</TermsCheckboxContext.Provider>
	);
};

export default TermsCheckboxStore;
